import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';

const ViewEmployees = ({employeeId}) => {
    const [employeeData, setEmployeeData] = useState(null);
    const [departments, setDepartments] = useState([]);
   
    const fetchEmployee = async (employeeId) => {      
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/users/${employeeId}`)
            .then(response => {
                setEmployeeData(response.data.data);         
            })
            .catch(error => {
                console.log(error);
                setEmployeeData([]); 
            });
    }

    const fetchDepartments = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/department`)
            .then(response => {
                setDepartments(response.data.data);
            })
            .catch(error => {
                console.error('Error fetching departments', error);
            });
    };

    useEffect(() => {
        if (employeeId) {
            fetchEmployee(employeeId);
        }
        fetchDepartments();
    },[employeeId]);

    if (!employeeId || !employeeData) {
        return null;
    }

    return (
        <div id={`view_employee_${employeeId}`} className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Employee - {employeeData.name} 
                            <small className="text-muted"> ({employeeData.designation})</small>
                        </h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="row">                                
                                <div className="col-sm-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Employee ID</label>
                                        <input className="form-control" type="text" value={employeeData.emp_id} disabled/>
                                    </div>
                                </div>                                
                                <div className="col-sm-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Email</label>
                                        <input className="form-control" type="text" value={employeeData.email} disabled/>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Joining Date</label>
                                        <input className="form-control" type="date" value={employeeData.joined_date} disabled/>
                                    </div>
                                </div>                                
                                <div className="col-sm-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Designation</label>
                                        <input className="form-control" type="text" value={employeeData.designation} disabled/>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Date of Birth</label>
                                        <input className="form-control" type="date" value={employeeData.dob || ''} disabled/>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Department</label>
                                        <select className="form-control" value={employeeData.department_id || ""} disabled>
                                            {departments.map(dep => (
                                                <option key={dep.id} value={dep.id}>{dep.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Address</label>
                                        <textarea className="form-control" type="text" disabled>{employeeData.address || ""}</textarea>
                                    </div>
                                </div>                            
                                <div className="col-sm-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Personal Email </label>
                                        <input className="form-control" type="text" value={employeeData.personal_email || ""} disabled/>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Personal Phone</label>
                                        <input className="form-control" type="text" value={employeeData.phone_number || ""} disabled/>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Emergency Phone </label>
                                        <input className="form-control" type="text" value={employeeData.home_phone || ""} disabled/>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewEmployees